import { PaymentMethod, TakeOrderStatus } from "../../proto/nbchat-proto";

export const orderStatusText: Record<
  number,
  {
    text: string;
    color: string;
    order_status_title: string;
    order_status_text: string;
    order_status_text_next: string;
    next_factor: string;
    order_status_color: string;
    description: string;
  }
> = {
  [TakeOrderStatus.PENDING]: {
    text: "待卖家确认订单",
    color: "rgb(192, 94, 252)",
    order_status_title: "",
    order_status_text: "待卖家确认订单",
    order_status_text_next: "卖家已确认订单",
    next_factor: "approved",
    order_status_color: "primary",
    description: "您好, 请确认订单信息",
  },
  [TakeOrderStatus.PENDING_TIMEOUT]: {
    text: "订单超时",
    color: "rgb(255, 0, 0)",
    order_status_title: "",
    order_status_text: "订单超时",
    order_status_text_next: "订单超时",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单在确认订单信息阶段超时",
  },
  [TakeOrderStatus.CANCELLED]: {
    text: "买家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "买家取消交易",
    order_status_text_next: "买家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.SELLER_CANCELLED]: {
    text: "卖家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "卖家取消交易",
    order_status_text_next: "卖家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.MATCHING]: {
    text: "待付款",
    color: "rgb(224, 113, 50)",
    order_status_title: "",
    order_status_text: "订单已建立",
    order_status_text_next: "订单已建立",
    next_factor: "",
    order_status_color: "primary",
    description: "请根据我的收款信息完成支付, 并上传转账凭证, 谢谢",
  },
  [TakeOrderStatus.MATCHING_CANCELLED]: {
    text: "买家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "买家取消交易",
    order_status_text_next: "买家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.MATCHING_TIMEOUT]: {
    text: "转账阶段超时",
    color: "rgb(255, 0, 0)",
    order_status_title: "",
    order_status_text: "转账阶段超时",
    order_status_text_next: "转账阶段超时",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单在缴款阶段超时",
  },
  [TakeOrderStatus.DELIVERING]: {
    text: "待卖家发货",
    color: "rgb(192, 94, 252)",
    order_status_title: "",
    order_status_text: "买家完成转账, 待卖家确认",
    order_status_text_next: "买家完成转账, 卖家已验证",
    next_factor: "settled",
    order_status_color: "primary",
    description: "我已支付, 请查收, 谢谢您",
  },
  [TakeOrderStatus.SETTLED]: {
    text: "卖家已发货,待评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "卖家已发货",
    order_status_text_next: "卖家已发货",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成, 待评价",
  },
  [TakeOrderStatus.DELIVERY_TIMEOUT]: {
    text: "订单已转系统验证",
    color: "rgb(161, 161, 161)",
    order_status_title: "发货超时",
    order_status_text: "订单已转系统验证",
    order_status_text_next: "订单已转系统验证",
    next_factor: "",
    order_status_color: "danger",
    description: "卖家发货超时，订单已转系统验证",
  },
  [TakeOrderStatus.DISPUTE]: {
    text: "待系统发货",
    color: "rgb(90, 149, 236)",
    order_status_title: "",
    order_status_text: "交易由系统接手, 待系统验证",
    order_status_text_next: "系统已验证",
    next_factor: "settled",
    order_status_color: "primary",
    description: "等待系统处理中",
  },
  [TakeOrderStatus.SYSTEM_CANCELLED]: {
    text: "系统取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "系统取消交易",
    order_status_text_next: "系统取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单已由系统取消",
  },
  [TakeOrderStatus.SYSTEM_SETTLED]: {
    text: "系统已发货",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "系统已发货",
    order_status_text_next: "系统已发货",
    next_factor: "",
    order_status_color: "success",
    description: "已由系统交易完成, 请查收",
  },
  [TakeOrderStatus.EVALUATED]: {
    text: "交易完成,买家已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,买家已评价",
    order_status_text_next: "交易完成,买家已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,买家已评价",
  },
  [TakeOrderStatus.EVALUATED_SR]: {
    text: "交易完成,卖家已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,卖家已评价",
    order_status_text_next: "交易完成,卖家已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,卖家已评价",
  },
  [TakeOrderStatus.EVALUATED_ALL]: {
    text: "交易完成,已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,已评价",
    order_status_text_next: "交易完成,已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,已评价",
  },
};

export const paymentMethodTextMap = {
  [PaymentMethod.BANK]: "银行卡",
  [PaymentMethod.ALIPAY]: "支付宝",
  [PaymentMethod.WECHAT]: "微信",
};

export const timeoutStatuses = [
  TakeOrderStatus.DELIVERY_TIMEOUT,
  TakeOrderStatus.MATCHING_TIMEOUT,
  TakeOrderStatus.PENDING_TIMEOUT,
];

export const cancelStatuses = [
  TakeOrderStatus.CANCELLED,
  TakeOrderStatus.MATCHING_CANCELLED,
  TakeOrderStatus.SELLER_CANCELLED,
  TakeOrderStatus.SYSTEM_CANCELLED,
];

export const settleStatuses = [
  TakeOrderStatus.SETTLED,
  TakeOrderStatus.SYSTEM_SETTLED,
  TakeOrderStatus.EVALUATED,
  TakeOrderStatus.EVALUATED_SR,
  TakeOrderStatus.EVALUATED_ALL,
];
